module.exports = __webpack_public_path__ + "img/quest_icon_0053_target2.8c900067.png";